module.exports = __webpack_public_path__ + "static/img/logo5.10b4073.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/customers/logo5.png
// module id = h+yO
// module chunks = 1